import { render, staticRenderFns } from "./CustumNotificationView.vue?vue&type=template&id=e337cf5c&"
import script from "./CustumNotificationView.vue?vue&type=script&lang=js&"
export * from "./CustumNotificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports